// @ts-nocheck
/* eslint-disable */
import { TuiComboBoxComponent } from '@taiga-ui/kit';
import { Directive, inject, Input, OnInit } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'tui-combo-box[clearable]',
  standalone: true,
})
export class TuiComboBoxClearableDirective<T> implements OnInit {
  private readonly comboBox = inject<TuiComboBoxComponent<T>>(TuiComboBoxComponent);

  @Input({ required: true }) clearable = true;

  public constructor() {
    const comboBox = this.comboBox as unknown as { onValueChange: (value: string) => void };
    const self = this;

    comboBox.onValueChange = function (this: TuiComboBoxComponent<T>, value: string): void {
      this.updateSearch(value);

      const match = this.accessor?.getOptions().find(item => this.isStrictMatch(item));

      if (match !== undefined) {
        this.value = match;
        this.updateSearch(null);

        return;
      }

      if ((this.strict || this.search === '') && self.clearable) {
        this.value = null;
      }

      this.hostedDropdown?.updateOpen(true);
    };
  }
}
